@if (isshowEditPopup) {
  <div id="overlay"></div>
}

<div class="equipment-bar-header" [ngClass]="themeClass ? 'dark-theme' : 'light-theme'">
  <div class="d-flex justify-content-between">
    <div>
      <span class="timeText"><em class="fa fa-temperature-low p-r-10"></em> <span>{{temperatureInfo}} F</span> </span>
    </div>
    @if (infoPoints.length == 0 && editor_mode == 'edit') {
      <div>
        <span class="noPointText">Add points to feeds</span>
        <span class="addPointText" (click)="addPointModel()">ADD POINTS</span>
      </div>
    }
    @if (infoPoints.length > 0) {
      <div class="notranslate">
        @for (info of infoPoints; track info; let i = $index; let last = $last) {
          <span [attr.data-index]="i">
            @if (infotooltipCount >= info.dis.length ) {
              <span class="infoPointName">{{info.dis}}</span>
            }
            @if (info.dis.length >  infotooltipCount) {
              <span matTooltip="{{info.dis}}" matTooltipPosition="above"
                matTooltipClass="pointnametooltip"
              class="infoPointName">{{showEllipses(info.dis,infotooltipCount)}}</span>
            }
            <span [ngClass]="themeClass ? 'infoPointValue-darkview' : 'infoPointValue'" > {{addUnitToValue(info)}} </span>
            @if (!last) {
              <span class="editVerticalLine">|</span>
            }
          </span>
        }
        @if (listpointData.length > pointLimit) {
          <div class="arrows">
            <em (click)="upArrowClicked()" class="fa-solid fa-chevron-up cursor-pointer visible arrow-up"
            [ngClass]="{'visibility-hidden' : isDisableTop, 'm-t-3': isDisableBottom}"></em>
            <em (click)="downArrowClicked()" class="fa-solid fa-chevron-down cursor-pointer visible arrow-down"
            [ngClass]="{'visibility-hidden' : isDisableBottom, 'arrow-down-single' : isDisableTop}"></em>
          </div>
        }
      </div>
    }
    <div class="relative">
      @if (editor_mode == 'edit') {
        <span (click)="showEditPopup(true)" class="editButton">
          EDIT
        </span>
      }
      <div [ngClass]="{'showEditpopup' : isshowEditPopup}" class="editBox">
        <div class="d-flex">
          <div class="statusFeedText">Status Feed</div>
          <div (click)="[addPointModel(),showEditPopup(false)]" class="editAddpoint">ADD POINT</div>
        </div>

        <div class="selectedPoint p-b-6">
          Selected Points
        </div>


        @if (showDeleteWarning) {
          <div  class="row align-items-start m-t-30 m-b-10 warningtext">
            <div class="col-2 text-center">
              <i class="fa fa-exclamation-triangle color-primary fa-lg m-t-10"></i>
            </div>
            <div class="col-10 p-l-0 pre-wrap">
              <p class="warningtext">Are you sure you want to Delete the Point ?</p>
              <div class="d-flex justify-content-end deleteWarningButton m-t-15">
                <button (click)="cancelDelete()" class="btn btn-text"> Cancel</button>
                <button (click)="confirmDeletePoint()" class="btn btn-text">
                Delete</button>
              </div>
            </div>
          </div>
        }

        @if (!showDeleteWarning) {
          <div class="pointContainer">
            <div cdkDropList [cdkDropListData]="masterPointList"  #divToScroll  class="container" (cdkDropListDropped)="drop($event)">
              @for (point of masterPointList; track point) {
                <div class="oddBackground" cdkDrag>
                  <div class="d-flex">
                    <div>
                      <mat-checkbox [(ngModel)]="point.master">
                        @if (edittooltipCount >= point.pointName.length ) {
                          <span
                          class="editPointText notranslate">{{point.pointName}}</span>
                        }
                        @if (point.pointName.length >  edittooltipCount) {
                          <span matTooltip="{{point.pointName}}"
                            matTooltipPosition="above" matTooltipClass="pointnametooltip"
                          class="editPointText notranslate">{{showEllipses(point.pointName,edittooltipCount)}}</span>
                        }
                      </mat-checkbox>
                    </div>
                    <div (click)="deletePoint(point)" class="deleteButton"><em
                    class="fa-solid fa-xmark"></em></div>
                  </div>
                </div>
              }
            </div>
          </div>
        }

        @if (!showDeleteWarning) {
          <div class="d-flex justify-content-end align-items-center p-t-10">
            <div (click)="showEditPopup(false)" class="btn color-primary editContainerBtn">CANCEL</div><span
          class="verticalLine">|</span>
          <div (click)="[savePoint(),showEditPopup(false)]" class="btn color-primary editContainerBtn">SAVE
          </div>
        </div>
      }

    </div> @if (allPointsData?.length > 0 && editor_mode == 'edit') {
    <span class="p-r-20 editVerticalLine">|</span>
  }
  <span class="timeText" id="time">{{ today | date: 'HH:mm' }}<span></span><em
class="fa fa-clock p-l-10"></em></span>
</div>
</div>
</div>
